import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static classes = ['hidden']
  static values = { timeout: Number }

  connect () {
    setTimeout(() => {
      this.dismiss()
    }, this.timeoutValue * 1000 + 500)
  }

  dismiss () {
    this.element.classList.add(this.hiddenClass)
  }
}
